// extracted by mini-css-extract-plugin
module.exports = {"item":"search_filters_bar_item-module__item--2bcs-"};